import { css } from 'styled-components'

export const BaseStyledBadge = css`
  color: ${({ theme }) => theme.colors.white};
  cursor: help;
  font-size: 11px;
  font-weight: 600;
`
